import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';

export default function emplacementDisponibiliteInitializer(emplacement) {
  let type = '';
  if (emplacement.panneaux) {
    type = 'panneaux';
  }
  if (!emplacement[type] || emplacement[type].length === 0) {
    emplacement.niveauDisponibilite = niveauDispo.NON_DISPONIBLE;
    return;
  }
  emplacement.niveauDisponibilite = niveauDispo.DISPONIBILITE_INDEFINI;
  emplacement.surface = 0;
  emplacement[type].forEach((type) => {
    if (type.niveauDisponibilite > emplacement.niveauDisponibilite) {
      emplacement.niveauDisponibilite = type.niveauDisponibilite;
    }
    if (type.surface > emplacement.surface) {
      emplacement.surface = type.surface;
    }
  });
  emplacement.color = niveauDispo.ICON_COULEUR_DISPONIBILITE[emplacement.niveauDisponibilite];
  if (emplacement.selected) {
    emplacement.color = niveauDispo.COULEUR_SELECTION;
  }
}




// WEBPACK FOOTER //
// ./src/services/catalogue/emplacementsDisponibiliteInitializer.js